import { BriefPage } from 'features/briefs/components/brief-page'
import * as React from 'react'
import { useParams } from 'react-router-dom'
import { EMAIL_DETAILS_TAB } from 'features/briefs/utils/nav'
import Row from 'components/common/row'
import { TextField } from 'components/ds'
import Label from 'components/ui/label'
import { useDispatch, useSelector } from 'hooks/use-redux'
import { getBrief } from '@disco/state-management/reducers/entities/briefs'
import { updateBrief } from '@disco/state-management/reducers/entities/briefs'
import { getUser } from '@disco/state-management/selectors/user'

const rowSizes = {
  6_6: [6, 6],
}

export const BriefEditorEmailPage = () => {
  const params = useParams<{ briefId: string }>()
  const dispatch = useDispatch()
  const brief = useSelector(state =>
    getBrief(state, { briefId: parseInt(params.briefId!) }),
  )

  const user = useSelector(getUser)

  return (
    <BriefPage step={EMAIL_DETAILS_TAB} title={EMAIL_DETAILS_TAB}>
      <Row columnsSize={rowSizes[6_6]}>
        <div>
          <Label caption="Reply-To address" />
          <TextField.Root
            size="2"
            id="sender_email"
            type="email"
            value={brief?.sender_email ?? user?.email}
            autoComplete="email"
            onChange={event => {
              dispatch(
                updateBrief({ ...brief, sender_email: event.target.value }),
              )
            }}
          />
        </div>
        <div>
          <Label caption="Email subject" />
          <TextField.Root
            size="2"
            id="subject"
            type="text"
            value={brief?.template_data?.subject}
            spellCheck
            onChange={event => {
              dispatch(
                updateBrief({
                  ...brief,
                  template_data: {
                    ...brief.template_data,
                    subject: event.target.value,
                  },
                }),
              )
            }}
          />
        </div>
      </Row>
      <Row columnsSize={rowSizes[6_6]}>
        <div>
          <Label caption="Sender display name" />
          <TextField.Root
            size="2"
            id="sender_name"
            type="text"
            value={
              brief?.sender_name ?? `${user?.first_name} ${user?.last_name}`
            }
            autoComplete="name"
            onChange={event => {
              dispatch(
                updateBrief({ ...brief, sender_name: event.target.value }),
              )
            }}
          />
        </div>
      </Row>
    </BriefPage>
  )
}
